const UtilsHelper = {
  stripTags(value) {
    return value && value.replace(/<\/?[^>]+(>|$)/g, '');
  },
};

export default UtilsHelper;
